import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { z } from 'zod';
import { DiscountType } from './discount.type.enum';

export const DiscountSchema = z
    .object({
        fixed: z.number().optional(),
        percentage: z.number().min(-100).max(100).optional(),
        type: EnumSchema(DiscountType),
    })
    .strict()
    .refine((fee) => typeof fee.fixed !== 'number' || +fee.fixed.toFixed(2) === fee.fixed, {
        message: 'fixed must have no more than 2 decimal places',
        path: ['fixed'],
    })
    .refine((fee) => typeof fee.percentage !== 'number' || +fee.percentage.toFixed(2) === fee.percentage, {
        message: 'percentage must have no more than 2 decimal places',
        path: ['percentage'],
    });

export class Discount extends FromSchema(DiscountSchema) {
    type: DiscountType;
    fixed?: number;
    percentage?: number;
}
